module.exports = __webpack_public_path__ + "static/img/appstore.d306a4e4.svg";